/* REACT */
import React, { useMemo, useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */
import Rating from '../../../ui/rating/rating'

/* STORE */
import { setIsPopoverChatOpen } from '../../../../store/general/actions'

/* STYLES */
import {
  TrophyContainer,
  TrophyImage,
  ItemImageWrapper,
  ItemImage,
  Title,
  TitleWrapper,
  GridItemWrapper,
  TripTypeWrapper,
  TripTypeOnCard,
  TripDetailsWrapper,
  TripSecondaryDetailsWrapper,
  GridItemDetailsWrapper,
  TripPriceWrapper,
  TripPriceFlex,
  TripPrice,
  TripPriceDisclaimer,
  TripSecondaryDetailItemWrapper,
  TripSecondaryDetail,
  TripDescriptionWrapper,
  TripDescription,
  TripTypeLabelWrapper,
  TripTypeLabel,
  TripSecondaryDetailSeparator,
  TripRatingWrapper,
  TripDisclaimerWrapper,
  TripDisclaimer,
} from './style'

/* UTILS/CONSTANTS*/
import {
  CLOUDFRONT_BASE_URL,
  CLIENT_STYLINGS,
} from '../../../../utils/constants'
import { Analytics, getTranslations } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`
const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

const TripItem = ({
  index,
  isLessThanLaptop,
  item,
  router,
  language,
  setIsPopoverChatOpen,
  key,
  openPopoverChatOnClickthrough,
  showRelevancyInfo,
  randomMatch,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const {
    name,
    images,
    price,
    destinations,
    label_image,
    duration,
    trip_info,
    label_card,
    rating_image,
    keywords,
    rating_value,
    rating_total_value,
    description,
    label_bottom,
    label_top,
  } = item

  const [tripPrice, setTripPrice] = useState(price)
  const [earlyBookingTripPrice, setEarlyBookingTripPrice] = useState(null)
  const [keywordsText, setKeywordsText] = useState(null)
  const [durationInDays, setDurationInDays] = useState(duration)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  const setWidthOfNameDiv = () => {
    // IF THERE IS LABEL CARD THEN ADJUST WIDTH OF NAME DIV
    const labelCardDiv = document.getElementById(`trip-label-card-${index}`)
    if (!labelCardDiv) {
      return
    }

    const mainDiv = document.getElementById(
      `grid-item-details-wrapper-${index}`
    )
    const nameDiv = document.getElementById(`trip-title-wrapper-${index}`)

    if (nameDiv && mainDiv) {
      // ADD 20PX FOR THE PADDING
      nameDiv.style.width = `${
        mainDiv.offsetWidth - labelCardDiv.offsetWidth - 20
      }px`
    }
  }

  useEffect(() => {
    setWidthOfNameDiv()
  }, [key, index])

  useEffect(() => {
    // SET TRIP PRICE
    if (item?.trip_info?.length) {
      for (let info of item.trip_info) {
        if (info?.selling_price) {
          // SET PRICE IF NOT SET
          setTripPrice(info.selling_price)

          if (info?.duration_in_days && !duration) {
            // SET DURATION IF NOT SET
            setDurationInDays(info.duration_in_days)
          }

          if (info?.early_booking_price) {
            // SET EARLY BOOKING PRICE
            setEarlyBookingTripPrice(info.early_booking_price)
          }

          break
        }
      }
    }

    if (keywords?.length) {
      let keywordsString = ''
      for (let keyword of keywords) {
        if (keywordsString.length > 0) keywordsString += ' | '
        keywordsString += `${keyword}`
      }

      setKeywordsText(keywordsString)
    }
  }, [key])

  const destinationsText = useMemo(() => {
    if (destinations?.length) {
      let text = ''
      let index = 0
      for (let destination of destinations) {
        if (index) {
          text += `, `
        }
        text += `${destination}`
        index += 1
      }
      return text
    }
    return ''
  }, [destinations])

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        Analytics.getInstance().sendEvent('maya_click_grid_item', {
          item_entity: 'trips',
          item_title: name,
          item_subtitle: tripPrice,
          item_type: label_image,
          item_destination: destinations[0],
          item_url: item.url,
        })
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
        if (openPopoverChatOnClickthrough) {
          setIsPopoverChatOpen(true)
        }
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper id={`grid-item-details-wrapper-${index}`}>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}>
            {label_top === 'gold' || label_top === 'silver' ? (
              <TrophyContainer label_top={label_top}>
                <TrophyImage
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  class='tss-4ulsz2-icon'
                >
                  <path
                    fill={label_top === 'gold' ? '#95701e' : '#808080'}
                    fill-rule='evenodd'
                    d='M18 4H6v7a5.99 5.99 0 0 0 5 5.917V19c-.889 0-1.687.386-2.236 1A2.989 2.989 0 0 0 8 22h8c0-.768-.289-1.47-.764-2-.55-.614-1.348-1-2.236-1v-2.083A5.99 5.99 0 0 0 18 11V4Zm-2 2H8v5c0 1.98 1.44 3.627 3.33 3.945l.67.112.67-.112A4.002 4.002 0 0 0 16 11V6ZM3 10.236A2.997 2.997 0 0 0 5 11V6H3a1 1 0 0 0-1 1v1c0 .889.386 1.687 1 2.236ZM19 6v5a2.997 2.997 0 0 0 3-3V7a1 1 0 0 0-1-1h-2Z'
                    clip-rule='evenodd'
                  ></path>
                </TrophyImage>
              </TrophyContainer>
            ) : null}

            {tripPrice ? (
              <TripPriceWrapper>
                <TripPriceFlex>
                  <TripPriceDisclaimer>
                    {getTranslations('trip_price_disclaimer')}
                  </TripPriceDisclaimer>
                  <TripPrice>{tripPrice}</TripPrice>
                </TripPriceFlex>
              </TripPriceWrapper>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>
        <TripDetailsWrapper>
          {label_card ? (
            <TripTypeWrapper>
              <TripTypeOnCard id={`trip-label-card-${index}`}>
                <TripTypeLabelWrapper>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    data-name='Layer 1'
                    viewBox='0 0 48 48'
                  >
                    <path
                      fill={'#028e00'}
                      d='M40.57 2.4C30-4.07 11.15 3.9 6.08 10.24S-4.31 32 5.48 41.47s25.93 7.84 35.09 0 10.62-32.6 0-39.07Z'
                    ></path>
                  </svg>
                  <TripTypeLabel>{label_card}</TripTypeLabel>
                </TripTypeLabelWrapper>
              </TripTypeOnCard>
            </TripTypeWrapper>
          ) : null}
          {name || tripPrice || durationInDays ? (
            <TripSecondaryDetailsWrapper>
              {name ? (
                <>
                  <TitleWrapper id={`trip-title-wrapper-${index}`}>
                    <Title dangerouslySetInnerHTML={{ __html: name }}></Title>
                  </TitleWrapper>
                </>
              ) : null}

              {label_image ? (
                <TripSecondaryDetailItemWrapper>
                  {label_image === 'hotel' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M7 1a2 2 0 0 0-2 2v19h14V3a2 2 0 0 0-2-2H7Zm10 2H7v17h10V3ZM9 5h2v3H9V5Zm2 5H9v3h2v-3Zm-2 5h2v3H9v-3Zm6-10h-2v3h2V5Zm-2 5h2v3h-2v-3Zm2 5h-2v3h2v-3Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'aparthotel' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M7.408 4 5 6.751V20h6V4H7.408ZM3 22h18V9.376a1 1 0 0 0-.247-.659l-2.954-3.376A1 1 0 0 0 17.046 5H13V3a1 1 0 0 0-1-1H6.954a1 1 0 0 0-.753.341L3.247 5.717A1 1 0 0 0 3 6.376V22Zm16-2h-6V7h3.593L19 9.751V20ZM9 7H7v2h2V7Zm-2 4h2v2H7v-2Zm2 4H7v2h2v-2Zm6-4h2v2h-2v-2Zm2 4h-2v2h2v-2Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'appartement' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='-2 -1 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'villa' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M6 12V5.67l7-1.274V8H8v4H6Zm2 2H4v6h4v-6Zm0 8H2v-9a1 1 0 0 1 1-1h1V4l9.821-1.786A1 1 0 0 1 15 3.198V8h6a1 1 0 0 1 1 1v13H8Zm2-2V10h10v10h-6v-4h-2v4h-2Zm2-6v-2h2v2h-2Zm6-2h-2v2h2v-2Zm-2 4h2v2h-2v-2Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'bungalow' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='-2 -1 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'vakantieparken' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M4 8.665V14h2v-3h2v5H3a1 1 0 0 1-1-1V8.241a1 1 0 0 1 .304-.717l5-4.849a1 1 0 0 1 1.392 0l4.961 4.81L12 9.094v-.428l-4-3.88-4 3.88ZM12 20v-5.335l4-3.88 4 3.88V20h-4v-3h-2v3h-2Zm3.304-11.325a1 1 0 0 1 1.392 0l5 4.848a1 1 0 0 1 .304.718V21a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-6.759a1 1 0 0 1 .304-.717l5-4.849Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'camping' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M12 2 2.724 20.553A1 1 0 0 0 3.618 22h16.764a1 1 0 0 0 .894-1.447L12 2ZM5.236 20 11 8.472V20H5.236Zm13.528 0H13V8.472L18.764 20ZM11 14l-3 6h3v-6Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'kasteel' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M6 2H4v6l1 2v8l-1 2v2h16v-2l-1-2v-8l1-2V2h-2v2h-5V2h-2v2H6V2Zm0 4v1.528L6.236 8h11.528L18 7.528V6H6Zm11 4H7v8.472l-.211.422L6.236 20h11.528l-.553-1.106-.211-.422V10Zm-8 5a3 3 0 1 1 6 0v3H9v-3Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'landhuis' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M9 7.828V20h2v-4h2v4h2V7.828l-3-3-3 3ZM17 16v4h3v-4h-3Zm3-2h-3v-2h1.172L20 13.828V14Zm2 0v8H2v-9l3-3h2V7l3.586-3.586L12 2l1.414 1.414L17 7v3h2l3 3v1ZM5.828 12H7v2H4v-.172L5.828 12ZM7 16H4v4h3v-4Zm6-6V8h-2v2h2Zm0 2h-2v2h2v-2Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : label_image === 'pension' ? (
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='-2 -1 24 24'
                      style={{
                        minWidth: '18px',
                        minHeight: '18px',
                        width: '18px',
                        height: '18px',
                      }}
                    >
                      <path
                        fill={
                          CLIENT_STYLINGS[organizationDetails.slug].COLOR
                            .TEXT_COLOR
                        }
                        fill-rule='evenodd'
                        d='M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h4a2 2 0 0 1 2 2v11H0V2Zm12 17V2H2v17h10Zm2 0h4v-9h-4v9ZM4 4h2v3H4V4Zm2 5H4v3h2V9Zm-2 5h2v3H4v-3Zm6-10H8v3h2V4ZM8 9h2v3H8V9Zm2 5H8v3h2v-3Z'
                        clip-rule='evenodd'
                      ></path>
                    </svg>
                  ) : null}

                  <TripSecondaryDetail>{label_image}</TripSecondaryDetail>
                  <TripSecondaryDetailSeparator></TripSecondaryDetailSeparator>
                  <TripRatingWrapper>
                    {[...Array(Math.floor(rating_value))].map((_, index) => (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        style={{
                          minWidth: '16px',
                          minHeight: '16px',
                          width: '16px',
                          height: '16px',
                        }}
                      >
                        <path
                          fill='#f8bb32'
                          d='M11.547 4.964a.5.5 0 0 1 .906 0l1.906 4.061a.5.5 0 0 0 .377.282l4.302.657a.5.5 0 0 1 .282.844l-3.144 3.223a.5.5 0 0 0-.135.43l.738 4.523a.5.5 0 0 1-.736.518L12.242 17.4a.5.5 0 0 0-.484 0l-3.801 2.1a.5.5 0 0 1-.736-.517l.738-4.524a.5.5 0 0 0-.135-.43L4.68 10.809a.5.5 0 0 1 .282-.844l4.302-.657a.5.5 0 0 0 .377-.282l1.906-4.06Z'
                        ></path>
                      </svg>
                    ))}
                  </TripRatingWrapper>
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {destinations?.length ? (
                <TripSecondaryDetailItemWrapper>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    style={{
                      minWidth: '18px',
                      minHeight: '18px',
                      width: '18px',
                      height: '18px',
                    }}
                  >
                    <path
                      fill={
                        CLIENT_STYLINGS[organizationDetails.slug].COLOR
                          .TEXT_COLOR
                      }
                      fill-rule='evenodd'
                      d='M18 10c0 2.743-1.587 5.268-3.456 7.254a21.66 21.66 0 0 1-2.515 2.271l-.029.023-.029-.023a21.66 21.66 0 0 1-2.515-2.27C7.587 15.267 6 12.742 6 10a6 6 0 1 1 12 0Zm2 0c0 7-8 12-8 12s-8-5-8-12a8 8 0 1 1 16 0Zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'
                      clip-rule='evenodd'
                    ></path>
                  </svg>
                  <TripSecondaryDetail>{destinationsText}</TripSecondaryDetail>
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {duration?.length ? (
                <TripSecondaryDetailItemWrapper>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    style={{
                      minWidth: '18px',
                      minHeight: '18px',
                      width: '18px',
                      height: '18px',
                    }}
                  >
                    <path
                      fill={
                        CLIENT_STYLINGS[organizationDetails.slug].COLOR
                          .TEXT_COLOR
                      }
                      fill-rule='evenodd'
                      d='M6 3a1 1 0 0 1 2 0v2h8V3a1 1 0 1 1 2 0v2h2a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V3Zm14 4H4v2h16V7Zm0 4H4v9h16v-9Zm-2 3v4h-4v-4h4Z'
                      clip-rule='evenodd'
                    ></path>
                  </svg>

                  <TripSecondaryDetail>{duration}</TripSecondaryDetail>
                </TripSecondaryDetailItemWrapper>
              ) : null}

              {description ? (
                <TripDescriptionWrapper>
                  <TripSecondaryDetail>{description}</TripSecondaryDetail>
                </TripDescriptionWrapper>
              ) : null}

              {label_bottom ? (
                <TripDisclaimerWrapper>
                  <TripDisclaimer>{label_bottom}</TripDisclaimer>
                </TripDisclaimerWrapper>
              ) : null}
            </TripSecondaryDetailsWrapper>
          ) : null}
        </TripDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  openPopoverChatOnClickthrough: state?.general?.openPopoverChatOnClickthrough,
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({
  setIsPopoverChatOpen: isOpen => dispatch(setIsPopoverChatOpen(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TripItem)
